// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39plz","colMin":"styles_colMin__x3rxr"};